module.exports = __webpack_public_path__ + "static/img/jiaoyu-m.ab75f08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jiaoyu-m.png
// module id = 9Rd4
// module chunks = 0